/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const CREATE_ACTION = gql`
  mutation CreateAction($input: ActionInput!) {
    createAction(data: $input)
  }
`
